/******************************************************************************************
 *	Customers Service
 ********************************************************************************************/
(function() {
  

  angular.module('rcServices.customers', []).service(
    'Customers',
    /* @ngInject */
    function(
      _,
      $log,
      $q,
      configurationReady,
      CustomersResponseTransformer,
      DemoMode,
      jilResellerCustomers,
      MiniJil,
      User
    ) {
      //Get all customers for a segment
      this.get = function(segment, payload) {
        if (DemoMode.isEnabled()) {
          const data = MiniJil.getCustomers(segment, payload);
          if (data) {
            return $q.resolve(CustomersResponseTransformer(data, {}));
          } else {
            return $q.reject({
              data: {},
              status: 404
            });
          }
        } else {
          const deferred = $q.defer();
          jilResellerCustomers.segments
            .get(_.assignIn({}, payload, {resellerId: User.getResellerID(), segment}))
            .$promise.then(responseData => {
              deferred.resolve(CustomersResponseTransformer(responseData));
            })
            .catch(err => {
              if (err.status === 404) {
                // this is really a success for this call
                deferred.resolve(CustomersResponseTransformer(err.data));
              } else {
                $log.error('Failed to fetch customer segment data', err);
                deferred.reject(err);
              }
            });
          return deferred.promise;
        }
      };

      //Get data for CSV file for specified segment and payload
      this.getCsvData = function(segment, payload) {
        return jilResellerCustomers.segmentDownload.export(
          _.assignIn({}, payload, {resellerId: User.getResellerID(), segment})
        ).$promise;
      };

      //Invite new customer
      this.invite = function(payload) {
        if (DemoMode.isEnabled()) {
          const data = MiniJil.inviteCustomer(payload);
          if (data) {
            return $q.resolve(data);
          } else {
            return $q.reject({
              data: {},
              status: 404
            });
          }
        } else {
          return jilResellerCustomers.customers.save(
            _.assignIn({}, payload, {resellerId: User.getResellerID()})
          ).$promise;
        }
      };
    }
  );
})();
